import React, { useEffect, useState } from 'react';
import errorImage from "../assets/image/error.svg";
import i18n from "../i18n";

require("./_error-panel.scss");

export const ErrorPanel = (props) => {
    const [error, setError] = useState();
    const error400 = i18n.t('errorPanel.error400');
    const error401 = i18n.t('errorPanel.error401');
    const error404 = i18n.t('errorPanel.error404');
    const error500 = i18n.t('errorPanel.error500');
    const errorDefault = i18n.t('errorPanel.errorDefault');

    useEffect(() => {
        let error = props.error;
        if(error && error.response) {
            switch(error.response.status) {
                case 400:
                    setError(error400);
                    break;
                case 401:
                    setError(error401);
                    break;
                case 404:
                    setError(error404);
                    break;
                case 500:
                    setError(error500);
                    break;
                default:
                    setError(errorDefault);
                    break;

            }
        } else {
            setError(errorDefault);
        }
    }, []);

    function getClassName() {
        let names = ['error-panel'];
        if(props.size === 'sm') {
            names.push('error-panel-sm')
        } else if(props.size === 'md') {
            names.push('error-panel-md')
        } else if(props.size === 'lg') {
            names.push('error-panel-lg')
        }
        return names.join(' ');
    }

    return (
        <>
            <div className={getClassName()}>
                <div className="error-details">
                    <div className="error-description">
                        {error}
                    </div>
                </div>
                <div className="image-container">
                    <img src={errorImage} alt="" />
                </div>
            </div>
                
        </>
    );
}

export default ErrorPanel;

